import React, { useState, useEffect } from 'react';
import { Form, Card, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ClaimProjectReportDetailsNavigation from '@rd-web-markets/market/dist/technicalProof/ClaimProjectReportDetailsNavigation';
import ProjectReportTab from './ProjectReportTab';
import CompetentProfessionalDetails from '../claim_project_reports/competent_professional/CompetentProfessionalDetails';
import { setBreadcrumb, clearBreadcrumb } from '@rd-web-markets/shared/dist/store/features/navbarBreadcrumbSlice';
import FolderAndFileManagement from '@rd-web-markets/shared/dist/folders_and_files/FolderAndFileManagement';
import { useFileManagementUrlHandler } from '@rd-web-markets/shared/dist/hooks/useFileManagementUrlHandler';
import { useDispatch, useSelector } from 'react-redux';
import { useGetUserClaimGroupAbilities } from '../userAbilities';
import ProjectUpdates from './projectUpdates/ProjectUpdates';
import reportNotesService from './summarySection/reportNotes.service';
import ClaimProjectNotes from '@rd-web-markets/market/dist/technicalProof/ClaimProjectNotes';
const ClaimProjectReportDetails = _ref => {
  let {
    accountType,
    claimGroup,
    setClaimGroup,
    report,
    handleSubmit,
    handleChange,
    toggleOngoing,
    setReport,
    handleDateChange,
    handleSliceChange,
    isOngoing,
    handleTinyMce,
    handleDelete,
    company
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const userClaimGroupAbilities = useGetUserClaimGroupAbilities({
    user,
    claimGroup
  });
  const pageAccess = userClaimGroupAbilities.pages.ClaimProjectReportDetailPage;
  const {
    t
  } = useTranslation();
  const [key, goToTab, goToFolderQuery, fileUploaderUsers, modelName, modelType, modelId, getFileUploadersAndVirtualFolderPath] = useFileManagementUrlHandler();
  const dispatch = useDispatch();
  const [notesLoading, setNotesLoading] = useState(false);
  const {
    notes,
    setNotes,
    createNote,
    updateNote,
    deleteNote
  } = reportNotesService.useCrud(setNotesLoading, report.id);
  const reportNotesHandlers = {
    notes,
    setNotes,
    createNote,
    updateNote,
    deleteNote,
    loading: notesLoading,
    setLoading: setNotesLoading
  };
  useEffect(() => {
    if (claimGroup?.company) {
      dispatch(setBreadcrumb({
        label: claimGroup.company.name,
        path: `/${accountType}/companies/${claimGroup.company.id}/overview`
      }));
    }
    return () => dispatch(clearBreadcrumb());
  }, [claimGroup, accountType, dispatch]);
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(ClaimProjectReportDetailsNavigation, {
    claimGroup: claimGroup,
    report: report,
    page: "general"
  }), /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-primary"
  }, t('project_report')), /*#__PURE__*/React.createElement("p", null, t('this_could_be_a_subproject_of_a_bigger_commercial_product_or_a_specific_feature'))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Tabs, {
    onSelect: k => goToTab(k, report.id),
    activeKey: key,
    id: "uncontrolled-tab-example",
    className: "mb-3"
  }, pageAccess.canAccessProjectReportTab && /*#__PURE__*/React.createElement(Tab, {
    eventKey: "project_report_tab",
    title: t('project_report_tab')
  }, /*#__PURE__*/React.createElement(ProjectReportTab, {
    handleDateChange: handleDateChange,
    handleSubmit: handleSubmit,
    handleChange: handleChange,
    toggleOngoing: toggleOngoing,
    setReport: setReport,
    handleSliceChange: handleSliceChange,
    isOngoing: isOngoing,
    handleTinyMce: handleTinyMce,
    report: report,
    claimGroup: claimGroup,
    company: company,
    setClaimGroup: setClaimGroup,
    reportNotesHandlers: reportNotesHandlers
  })), pageAccess.canAccessDocumentsTab && /*#__PURE__*/React.createElement(Tab, {
    eventKey: "documents",
    title: t('documents')
  }, key === 'documents' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FolderAndFileManagement, {
    canEditExistingDocumentsOrFolders: pageAccess.canEditExistingDocumentsOrFolders,
    targetModelId: modelId,
    type: modelType,
    modelName: modelName,
    goToFolderQuery: goToFolderQuery,
    fileUploaderUsers: fileUploaderUsers,
    getFileUploadersAndVirtualFolderPath: getFileUploadersAndVirtualFolderPath,
    userClaimGroupAbilities: userClaimGroupAbilities
  }))), pageAccess.canAccessNotesTab && /*#__PURE__*/React.createElement(Tab, {
    eventKey: "notes",
    title: t('notes')
  }, /*#__PURE__*/React.createElement(ClaimProjectNotes, {
    isImmutableUnderReview: true,
    report: report,
    setReport: setReport,
    pageAccess: pageAccess,
    reportNotesHandlers: reportNotesHandlers
  })), pageAccess.canAccessCompetentProfessionalsTab && /*#__PURE__*/React.createElement(Tab, {
    eventKey: "competent_professional",
    title: t('competent_professional')
  }, key === 'competent_professional' && /*#__PURE__*/React.createElement(CompetentProfessionalDetails, {
    companyId: company.id
  })), pageAccess.canAccessProjectUpdatesTab && /*#__PURE__*/React.createElement(Tab, {
    eventKey: "project_updates",
    title: t('project_updates')
  }, key === 'project_updates' && /*#__PURE__*/React.createElement(ProjectUpdates, {
    report: report
  }))))));
};
export default ClaimProjectReportDetails;